// extracted by mini-css-extract-plugin
module.exports = {"qixi_share":"inviteSuccess_qixi_share__2Oh-m","load_btn":"inviteSuccess_load_btn__3ZNeN","mask":"inviteSuccess_mask__1F2YA"};